import { inject as controller } from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import DayDetailControllerBaseController from 'lumen/controllers/day-detail-controller-base';
import { RATE_PARAMS } from 'lumen/utils/constants/general-constants';

export default class HotelRatesDetailController extends DayDetailControllerBaseController {
  @service('hotel-and-market') hotelAndMarketService;
  @service router;

  @controller('hotel.rates') rates;

  get isBestFlex() {
    return this.rates?.rateParam === RATE_PARAMS.BEST_FLEX;
  }

  get ratesParams() {
    const { room } = this;
    return {
      los: this.rates?.los,
      mealtype: this.rates?.mealPlan === 0 ? null : this.rates?.mealPlan,
      persons: this.rates?.maxPersons,
      membershiptype: this.rates?.membershipType,
      room,
      ota: this.rates?.otaId,
      rateParam: this.rates?.rateParam,
      platform: this.rates?.platform,
      compset:
        this.hotelAndMarketService.availableCompsets?.length > 1
          ? this.rates?.compsetId
          : null,
    };
  }

  @action
  redirect() {
    this.router.legacyTransitionTo('hotel.rates');
  }
}
